<template>
  <a-modal
    wrapClassName="customModal"
    v-model="showModal"
    :title="title"
    @ok="saveClassRoom"
    :width="width"
    cancelText="取消"
    okText="确定"
    :confirmLoading="submitLoading"
    :afterClose="afterClose"
    :destroyOnClose="true"
  >
    <div class="classmodal_content">
      <delete-dialog
        :showModal.sync="deleteModalShow"
        tipMsg="听课教室删除后无法恢复，请谨慎操作"
        @delete="confirmDelete"
      />
      <!-- 无导播课堂 -->
      <a-row :flex="2">
        <a-col :span="12" :offset="2">
          <div class="content_btntab">
            <a-button
              class="ZHIHUISHU_QZMD"
              :type="roomType == ROOM_TYPE_ENUM.SIMPLE ? 'primary' : 'default'"
              size="large"
              @click="changeTab(ROOM_TYPE_ENUM.SIMPLE)"
              v-if="showSimpleTab"
            >
              无导播课堂
            </a-button>
            <a-button
              class="ZHIHUISHU_QZMD"
              :type="roomType == ROOM_TYPE_ENUM.WISDOM ? 'primary' : 'default'"
              size="large"
              @click="changeTab(ROOM_TYPE_ENUM.WISDOM)"
              v-if="showWisdomTab(ROOM_TYPE_ENUM.WISDOM)"
            >
              智慧教室（主讲）
            </a-button>
            <a-button
              :type="
                roomType == ROOM_TYPE_ENUM.SMALLEST ? 'primary' : 'default'
              "
              size="large"
              @click="changeTab(ROOM_TYPE_ENUM.SMALLEST)"
              v-if="showWisdomTab(ROOM_TYPE_ENUM.SMALLEST)"
            >
              极简教室（主讲）
            </a-button>
          </div>
        </a-col>
        <a-col :span="18" :offset="2" class="simple_box">
          <a-form
            :form="simpleForm"
            :colon="false"
            ref="simpleForm"
            v-show="roomType == ROOM_TYPE_ENUM.SIMPLE"
          >
            <a-form-item label="直播名称">
              <a-input
                placeholder="请输入直播名称（限50字）"
                autocomplete="off"
                v-decorator="[
                  'courseName',
                  {
                    rules: [
                      { required: true, message: '请输入直播名称（限50字）' },
                      { max: 50, message: '直播名称不得大于50字' },
                    ],
                  },
                ]"
                :maxLength="50"
                allowClear
              />
            </a-form-item>
            <h3>授课时间</h3>
            <div style="display: flex">
              <a-form-item label="开始时间">
                <a-time-picker
                  placeholder="开始时间"
                  v-decorator="[
                    'startTime',
                    {
                      rules: [{ required: true, message: '请选择时间' }],
                    },
                  ]"
                  format="HH:mm"
                />
              </a-form-item>
              <a-form-item label="结束时间" style="margin-left: 30px">
                <a-time-picker
                  placeholder="结束时间"
                  v-decorator="[
                    'endTime',
                    {
                      rules: [{ required: true, message: '请选择时间' }],
                    },
                  ]"
                  format="HH:mm"
                />
              </a-form-item>
              <a-form-item
                label="授课日期"
                style="margin-left: 30px; width: 50%"
              >
                <a-date-picker
                  placeholder="请选择日期"
                  v-decorator="[
                    'courseTime',
                    {
                      rules: [{ required: true, message: '请选择日期' }],
                    },
                  ]"
                  style="width: 100%"
                  @change="handleCourseTimeChange"
                >
                  <div>
                    <a-input :value="courseTimeStrSim" placeholder="日期">
                      <a-icon slot="suffix" type="calendar" />
                    </a-input>
                  </div>
                </a-date-picker>
              </a-form-item>
            </div>
            <div style="display: flex; margin-top: 20px">
              <a-form-item label="主讲学校（非必选）" style="width: 50%">
                <a-select
                  v-decorator="['schoolId']"
                  placeholder="请选择主讲学校"
                  @change="handleSchoolChange"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in schoolListSim"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                label="主讲教室（非必选）"
                style="width: 50%; margin-left: 30px"
              >
                <a-select
                  v-decorator="['classRoomId']"
                  placeholder="请选择主讲教室"
                  @change="(value) => this.handleClassRoomChange(value, true)"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    :value="item.classroomCode"
                    v-for="item in classRoomListSim"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomCode + '-' + item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <a-form-item label="主讲老师（非必选）">
              <a-select
                v-decorator="['teacherId']"
                placeholder="请选择主讲老师"
                showSearch
                optionFilterProp="children"
              >
                <a-select-option
                  :value="item.zhsId"
                  v-for="item in teacherListSim"
                  :key="item.zhsId"
                >
                  {{ item.zhsId + '-' + item.realName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </a-col>
        <!-- wisdom 智慧教室 -->
        <a-col :span="24" :offset="0" class="scroll-box" ref="scrollBox">
          <a-col :span="18" :offset="2">
            <a-form
              :form="wisdomForm"
              :colon="false"
              ref="wisdomForm"
              v-show="roomType == ROOM_TYPE_ENUM.WISDOM"
            >
              <a-form-item label="直播名称">
                <a-input
                  placeholder="请输入直播名称（限50字）"
                  autocomplete="off"
                  v-decorator="[
                    'liveName',
                    {
                      rules: [
                        { required: true, message: '请输入直播名称（限50字）' },
                        { max: 50, message: '直播名称不得大于50字' },
                      ],
                    },
                  ]"
                  :maxLength="50"
                  allowClear
                />
              </a-form-item>
              <h3>授课时间</h3>
              <div style="display: flex">
                <a-form-item label="开始时间">
                  <a-time-picker
                    placeholder="开始时间"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-decorator="[
                      'startTime',
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                  />
                </a-form-item>
                <a-form-item label="结束时间" style="margin-left: 30px">
                  <a-time-picker
                    placeholder="结束时间"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-decorator="[
                      'endTime',
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                  />
                </a-form-item>
                <a-form-item
                  label="授课日期"
                  style="margin-left: 30px; width: 50%"
                >
                  <a-date-picker
                    placeholder="请选择日期"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-decorator="[
                      'courseTimeWis',
                      {
                        rules: [{ required: true, message: '请选择日期' }],
                      },
                    ]"
                    style="width: 100%"
                    ref="range-picker"
                    :open="isShowCourseTimeWis"
                    @change="handleCourseTimeChange"
                  >
                    <div>
                      <a-input
                        @focus="isShowCourseTimeWis = true"
                        :value="courseTimeStrWis"
                        placeholder="日期"
                      >
                        <a-icon slot="suffix" type="calendar" />
                      </a-input>
                    </div>
                  </a-date-picker>
                </a-form-item>
              </div>
              <a-form-item label="主讲人">
                <a-input
                  placeholder="请填写主讲人"
                  autocomplete="off"
                  allowClear
                  v-decorator="[
                    'teacherName',
                    {
                      rules: [{ required: true, message: '请填写主讲人' }],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item label="主讲老师手机号">
                <a-input
                  placeholder="请填写主讲老师手机号"
                  autocomplete="off"
                  :maxLength="13"
                  allowClear
                  v-decorator="[
                    'teachPhone',
                    {
                      rules: [
                        {
                          pattern: /^1[34578]\d{9}$/,
                          message: '请输入正确手机号',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <h3>主讲教室配置</h3>
              <a-form-item label="主讲学校">
                <a-select
                  v-decorator="[
                    'schoolId',
                    {
                      rules: [{ required: true, message: '请选择主讲学校' }],
                    },
                  ]"
                  placeholder="请选择主讲学校"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @change="handleSchoolChange"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲教室">
                <a-select
                  v-decorator="[
                    'classRoomId',
                    {
                      rules: [{ required: true, message: '请选择主讲教室' }],
                    },
                  ]"
                  placeholder="请选择主讲教室"
                  @change="handleClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.classroomCode"
                    v-for="item in classRoomListWis"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲导播">
                <a-select
                  v-decorator="['teacherId']"
                  placeholder="请选择主讲导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListWis"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <h3>听课教室配置</h3>
              <a-form-item label="听课学校">
                <a-select
                  v-decorator="['listenSchool']"
                  placeholder="请选择听课学校"
                  @change="handleListenSchoolChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="听课教室">
                <a-select
                  v-decorator="['listenClassroom']"
                  placeholder="请选择听课教室"
                  @change="handleListenClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in listenClassRoomList"
                    :value="item.classroomCode"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                label="听课导播"
                style="position: relative; width: 50%"
              >
                <a-select
                  v-decorator="['listenDaobo']"
                  placeholder="请选择听课导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListListenWis"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
                <a-button
                  type="primary"
                  class="add_class_room_btn ZHIHUISHU_QZMD"
                  @click="handleAddListenClassRoomClick"
                >
                  添加一间教室
                </a-button>
              </a-form-item>
              <a-table
                :columns="columns"
                :data-source="listenData"
                :pagination="false"
                bordered
                :scroll="{ x: 780 }"
                class="content_table"
              >
                <template slot="schoolName" slot-scope="text">
                  <a>{{ text }}</a>
                </template>
                <span slot="action" slot-scope="text, record">
                  <a-button
                    class="ZHIHUISHU_QZMD"
                    type="danger"
                    @click="deleteListenOneData(text)"
                  >
                    删除
                  </a-button>
                </span>
              </a-table>
              <h3 style="margin-top: 15px">互动策略（导播可见）</h3>
              <a-form-item>
                <a-textarea
                  placeholder="请输入互动策略"
                  v-decorator="['tactics']"
                  :rows="4"
                />
              </a-form-item>
            </a-form>
          </a-col>
        </a-col>
        <!-- smallest 极简教室 纯极简当主讲 -->
        <a-col :span="24" :offset="0" class="scroll-box" ref="scrollBox">
          <a-col :span="18" :offset="2">
            <a-form
              :form="smallestForm"
              :colon="false"
              ref="smallestForm"
              v-show="roomType == ROOM_TYPE_ENUM.SMALLEST"
            >
              <a-form-item label="直播名称">
                <a-input
                  placeholder="请输入直播名称（限50字）"
                  autocomplete="off"
                  v-decorator="[
                    'liveName',
                    {
                      rules: [
                        { required: true, message: '请输入直播名称（限50字）' },
                        { max: 50, message: '直播名称不得大于50字' },
                      ],
                    },
                  ]"
                  :maxLength="50"
                  allowClear
                />
              </a-form-item>
              <h3>授课时间</h3>
              <div style="display: flex">
                <a-form-item label="开始时间">
                  <a-time-picker
                    placeholder="开始时间"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-decorator="[
                      'startTime',
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                  />
                </a-form-item>
                <a-form-item label="结束时间" style="margin-left: 30px">
                  <a-time-picker
                    placeholder="结束时间"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-decorator="[
                      'endTime',
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                  />
                </a-form-item>
                <a-form-item
                  label="授课日期"
                  style="margin-left: 30px; width: 50%"
                >
                  <a-date-picker
                    placeholder="请选择日期"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-decorator="[
                      'courseTimeWis',
                      {
                        rules: [{ required: true, message: '请选择日期' }],
                      },
                    ]"
                    style="width: 100%"
                    ref="range-picker"
                    :open="isShowCourseTimeSma"
                    @change="handleCourseTimeChange"
                  >
                    <div>
                      <a-input
                        @focus="isShowCourseTimeSma = true"
                        :value="courseTimeStrSma"
                        placeholder="日期"
                      >
                        <a-icon slot="suffix" type="calendar" />
                      </a-input>
                    </div>
                  </a-date-picker>
                </a-form-item>
              </div>
              <a-form-item label="主讲人">
                <a-input
                  placeholder="请填写主讲人"
                  autocomplete="off"
                  allowClear
                  v-decorator="[
                    'teacherName',
                    {
                      rules: [{ required: true, message: '请填写主讲人' }],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item label="主讲老师手机号">
                <a-input
                  placeholder="请填写主讲老师手机号"
                  autocomplete="off"
                  :maxLength="13"
                  allowClear
                  v-decorator="['teachPhone']"
                />
              </a-form-item>
              <h3>主讲教室配置</h3>
              <a-form-item label="主讲学校">
                <a-select
                  v-decorator="[
                    'schoolId',
                    {
                      rules: [{ required: true, message: '请选择主讲学校' }],
                    },
                  ]"
                  placeholder="请选择主讲学校"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  @change="handleSchoolChange"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲教室">
                <a-select
                  v-decorator="[
                    'classRoomId',
                    {
                      rules: [{ required: true, message: '请选择主讲教室' }],
                    },
                  ]"
                  placeholder="请选择主讲教室"
                  @change="handleClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in classRoomListSma"
                    :value="item.classroomCode"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲导播">
                <a-select
                  v-decorator="['teacherId']"
                  placeholder="请选择主讲导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListSma"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <h3>听课教室配置</h3>
              <a-form-item label="听课学校">
                <a-select
                  v-decorator="['listenSchool']"
                  placeholder="请选择听课学校"
                  @change="handleListenSchoolChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="听课教室">
                <a-select
                  v-decorator="['listenClassroom']"
                  placeholder="请选择听课教室"
                  @change="handleListenClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in listenClassRoomListSma"
                    :value="item.classroomCode"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                label="听课导播"
                style="position: relative; width: 50%"
              >
                <a-select
                  v-decorator="['listenDaobo']"
                  placeholder="请选择听课导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListListenSma"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
                <a-button
                  type="primary"
                  class="add_class_room_btn"
                  @click="handleAddListenClassRoomClick"
                >
                  添加一间教室
                </a-button>
              </a-form-item>
              <a-table
                :columns="columns"
                :scroll="{ x: 780 }"
                :data-source="listenDataSma"
                :pagination="false"
                bordered
                class="content_table"
              >
                <template slot="schoolName" slot-scope="text">
                  <a>{{ text }}</a>
                </template>
                <span slot="action" slot-scope="text, record">
                  <a-button type="danger" @click="deleteListenOneData(text)">
                    删除
                  </a-button>
                </span>
              </a-table>
              <h3 style="margin-top: 15px">互动策略（导播可见）</h3>
              <a-form-item>
                <a-textarea
                  placeholder="请输入互动策略"
                  v-decorator="['tactics']"
                  :rows="4"
                />
              </a-form-item>
            </a-form>
          </a-col>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { ROOM_TYPE_ENUM } from './const'

const columns = [
  {
    title: '学校名称',
    dataIndex: 'schoolName',
    scopedSlots: { customRender: 'schoolName' },
  },
  {
    title: '教室名称',
    dataIndex: 'className',
  },
  {
    title: '教室类型',
    dataIndex: 'roomType',
  },
  {
    title: '导播名称',
    dataIndex: 'realName',
  },
  {
    title: '手机号码',
    dataIndex: 'mobile',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  props: {
    type: {
      type: String,
      default: () => {
        return 'liveStreaming'
      },
    },
    width: {
      type: Number,
      default: () => 850,
    },
    showModalProp: {
      type: Boolean,
      default: () => false,
    },
    editFormData: {
      type: Object,
      default: () => {},
    },
    editModel: {
      type: Object,
      default: () => {},
    },
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ROOM_TYPE_ENUM,
      title: '添加直播',
      showModal: false,
      submitLoading: false,
      roomType: ROOM_TYPE_ENUM.SIMPLE, // 无导播课堂 simple 智慧教室直播 wisdom 极简教室直播 smallest
      formLayout: 'horizontal',
      simpleForm: this.$form.createForm(this, { name: 'simpleForm' }),
      wisdomForm: this.$form.createForm(this, { name: 'wisdomForm' }),
      smallestForm: this.$form.createForm(this, { name: 'smallestForm' }),
      courseTimeWis: undefined,
      courseTimeStrSim: '',
      courseTimeStrWis: '',
      courseTimeStrSma: '',
      listenData: [],
      listenDataSma: [],
      columns,
      schoolListSim: [], // 无导播课堂主讲学校列表
      schoolListWis: [], // 智慧课堂主讲学校列表
      classRoomListSim: [], // 无导播课堂主讲教室列表
      classRoomListWis: [], // 智慧课堂主讲教室列表
      classRoomListSma: [], // 极简主讲教室列表
      teacherListSim: [],
      teacherListWis: [],
      teacherListSma: [],
      teacherListListenWis: [],
      teacherListListenSma: [],
      listenClassRoomList: [],
      listenClassRoomListSma: [],
      isShowCourseTimeWis: false,
      isShowCourseTimeSma: false,
      isShowCourseTimeWis: false,
      deleteModalShow: false, // 删除弹框
      deleteData: {},
    }
  },
  components: {
    'delete-dialog': () => import('../../components/deleteDialog'),
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    showSimpleTab() {
      if (this.editModel?.show) {
        return this.editModel?.liveType == ROOM_TYPE_ENUM.SIMPLE
      } else {
        return true
      }
    },
  },
  watch: {
    showModalProp(newVal, oldVal) {
      this.showModal = newVal
      if (newVal) {
        this.setSchoolClassRoomTeacher()
      }
    },
    editModel(newVal, oldVal) {
      this.setEditInfo(newVal)
    },
  },
  created() {
    this.init()
  },
  destroyed() {
    let scrollBox = this.$refs.scrollBox?.$el
    if (scrollBox)
      scrollBox.removeEventListener('scroll', this.handScrollChange)
  },
  methods: {
    handScrollChange() {
      // 监听滚动关闭日期弹框
      this.isShowCourseTimeWis = false
      this.isShowCourseTimeSma = false
    },
    showWisdomTab(type) {
      if (this.editModel?.show) {
        if (type == ROOM_TYPE_ENUM.WISDOM) {
          return this.editModel?.liveType == ROOM_TYPE_ENUM.WISDOM
        }
        if (type == ROOM_TYPE_ENUM.SMALLEST) {
          return this.editModel?.liveType == ROOM_TYPE_ENUM.SMALLEST
        }
      } else {
        // 0 普通用户 1 管理员用户
        return this.userInfo.userType == 1
      }
    },
    changeTab(type) {
      this.roomType = type
      if (type == ROOM_TYPE_ENUM.WISDOM) {
        let scrollBox = this.$refs.scrollBox?.$el
        if (scrollBox) {
          scrollBox.removeEventListener('scroll', this.handScrollChange)
          scrollBox.addEventListener('scroll', this.handScrollChange)
        }
      }
      if (
        this.simpleForm.getFieldValue('schoolId') == undefined ||
        this.wisdomForm.getFieldValue('schoolId') == undefined
      ) {
        this.setSchoolClassRoomTeacher()
      }
    },
    setSchoolClassRoomTeacher() {
      this.$nextTick(async () => {
        if (this.editModel?.show) return
        if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
          this.simpleForm.setFieldsValue({
            schoolId: this.schoolListSim[0]?.id,
          })
          await this.handleSchoolChange(this.schoolListSim[0]?.id)
          await this.handleClassRoomChange(
            this.classRoomListSim[0]?.classRoomId
          )
        } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
          this.wisdomForm.setFieldsValue({
            schoolId: this.schoolListWis[0]?.id,
          })
          await this.handleSchoolChange(this.schoolListWis[0]?.id)
          await this.handleClassRoomChange(
            this.classRoomListWis[0]?.classroomCode
          )
        } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
          this.smallestForm.setFieldsValue({
            schoolId: this.schoolListWis[0]?.id,
          })
          await this.handleSchoolChange(this.schoolListWis[0]?.id)
          await this.handleClassRoomChange(
            this.classRoomListWis[0]?.classroomCode
          )
        }
      })
    },
    setEditInfo(val) {
      if (val.show) {
        this.title = '编辑直播'
        this.roomType = val.liveType
        this.$nextTick(async () => {
          if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
            await this.handleSchoolChange(this.editFormData.schoolCode)
            await this.handleClassRoomChange(this.editFormData.schoolId)
            let courseTime = new moment(
              this.editFormData.timeList[0]?.startTime
            )
            this.courseTimeStrSim = courseTime.format('YYYY-MM-DD')
            this.simpleForm.setFieldsValue({
              courseName: this.editFormData.courseName,
              schoolId: Number(this.editFormData.schoolCode) || '',
              classRoomId: this.editFormData.classRoomId || '',
              teacherId: Number(this.editFormData.teacherId) || '',
              courseTime,
              startTime: new moment(this.editFormData.timeList[0]?.startTime),
              endTime: new moment(this.editFormData.timeList[0]?.endTime),
            })
          } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
            await this.handleSchoolChange(
              this.editFormData.teachClass?.schoolId
            )
            await this.handleClassRoomChange(
              this.editFormData.teachClass.classCode
            )
            let courseTimeWis = new moment(this.editFormData.startTime)
            this.courseTimeStrWis = courseTimeWis.format('YYYY-MM-DD')
            this.wisdomForm.setFieldsValue({
              liveName: this.editFormData.liveName,
              teacherName: this.editFormData.teacherName,
              teachPhone: this.editFormData.teachPhone,
              schoolId: Number(this.editFormData.teachClass?.schoolId) || '',
              classRoomId: this.editFormData.teachClass?.classCode || '',
              teacherId: this.editFormData.teachClass?.supporterZhsId
                ? this.editFormData.teachClass?.supporterZhsId + ''
                : '' || '',
              tactics: this.editFormData.teachClass?.tactics,
              courseTimeWis,
              startTime: new moment(this.editFormData.startTime),
              endTime: new moment(this.editFormData.endTime),
            })
            this.listenData =
              this.editFormData.watchClassList?.map((item, index) => {
                return {
                  key: index,
                  schoolId: item.id,
                  schoolName: item.schoolName,
                  schoolCode: item.schoolId,
                  className: item.className,
                  roomType: '听课',
                  realName: item.supporterName,
                  mobile: item.supporterPhone,
                  schoolCode: item.schoolCode,
                  classCode: item.classCode,
                  email: item.email,
                  liveId: item.liveId,
                }
              }) || []
          } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
            await this.handleSchoolChange(
              this.editFormData.teachClass?.schoolId
            )
            await this.handleClassRoomChange(
              this.editFormData.teachClass?.classCode
            )
            let courseTimeWis = new moment(this.editFormData.startTime)
            this.courseTimeStrSma = courseTimeWis.format('YYYY-MM-DD')
            this.smallestForm.setFieldsValue({
              liveName: this.editFormData.liveName,
              teacherName: this.editFormData.teacherName,
              teachPhone: this.editFormData.teachPhone,
              schoolId: Number(this.editFormData.teachClass?.schoolId) || '',
              classRoomId: this.editFormData.teachClass?.classCode || '',
              teacherId: this.editFormData.teachClass?.supporterZhsId
                ? this.editFormData.teachClass?.supporterZhsId + ''
                : '' || '',
              tactics: this.editFormData.teachClass?.tactics,
              courseTimeWis,
              startTime: new moment(this.editFormData.startTime),
              endTime: new moment(this.editFormData.endTime),
            })
            this.listenDataSma =
              this.editFormData.watchClassList?.map((item, index) => {
                return {
                  key: index,
                  schoolId: item.id,
                  schoolName: item.schoolName,
                  schoolCode: item.schoolId,
                  className: item.className,
                  roomType: '听课',
                  realName: item.supporterName,
                  mobile: item.supporterPhone,
                  schoolCode: item.schoolCode,
                  classCode: item.classCode,
                  email: item.email,
                  liveId: item.liveId,
                }
              }) || []
          }
        })
      } else {
        this.title = '添加直播'
      }
    },
    handleCourseTimeChange(value, dateString) {
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        this.courseTimeStrSim = dateString
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        this.isShowCourseTimeWis = false
        this.courseTimeStrWis = dateString
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        this.isShowCourseTimeSma = false
        this.courseTimeStrSma = dateString
      }
    },
    moment,
    async init() {
      // 初始化各项的值
      try {
        let schoolRes = await this.$http.getSelectSchoolList()
        if (schoolRes.code !== 200) {
          throw '初始化学校失败!请稍候重试'
        } else {
          this.schoolListSim = schoolRes.rt
          this.schoolListWis = schoolRes.rt
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    // modal关闭
    afterClose() {
      this.title = '编辑直播'
      this.roomType = ROOM_TYPE_ENUM.SIMPLE
      this.courseTimeStrSim = ''
      this.courseTimeStrWis = ''
      this.courseTimeStrSma = ''
      this.listenData = []
      this.listenDataSma = []
      this.submitLoading = false
      this.$emit('update:showModalProp', false)
      this.$emit('close')
    },
    async confirmDelete() {
      let data = this.deleteData
      if (this.editModel?.show) {
        let res = await this.$http.removeWatchRoom({
          schoolCode: data.schoolCode || data.schoolId,
          classCode: data.classCode || data.classId,
          // liveId: data.liveId || this.editModel?.liveId,
          liveId: this.deleteData.liveId || ''
        })
        if (res.rt.resultStatus == -1 || res.code != 200) {
          return this.$message.error(res.rt.resultMessage || '删除失败')
        }
        if (data.key || data.key == 0) {
          if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
            const indexSpecial = (this.listenData || []).findIndex(v => v.key === data.key)
            this.listenData.splice(indexSpecial, 1)
          } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
            const indexSpecial = (this.listenDataSma || []).findIndex(v => v.key === data.key)
            this.listenDataSma.splice(indexSpecial, 1)
          }
        }
      } else {
        if (data.key || data.key == 0) {
          if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
            const indexSpecial = (this.listenData || []).findIndex(v => v.key === data.key)
            this.listenData.splice(indexSpecial, 1)
          } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
            const indexSpecial = (this.listenDataSma || []).findIndex(v => v.key === data.key)
            this.listenDataSma.splice(indexSpecial, 1)
          }
        }
      }
    },
    deleteListenOneData(data) {
      this.deleteModalShow = true
      this.deleteData = data
    },
    async handleAddListenClassRoomClick() {
      if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let data = this.wisdomForm.getFieldsValue()
        let school =
          this.schoolListWis.find((item) => item.id == data.listenSchool) || {}
        let classRoom =
          this.listenClassRoomList.find(
            (item) => item.classroomCode == data.listenClassroom
          ) || {}
        let teacher =
          this.teacherListListenWis.find(
            (item) => item.zhsId == data.listenDaobo
          ) || {}
        if (!data.listenSchool) {
          return
        }
        let selectDay = data.courseTimeWis
        selectDay?.hours(0)
        selectDay?.minutes(0)
        selectDay?.seconds(0)
        let submitStartTime =
          selectDay?.valueOf() +
          (data.startTime?.hour() * 60 + data.startTime?.minute()) * 60 * 1000
        let submitEndTime =
          selectDay?.valueOf() +
          (data.endTime?.hour() * 60 + data.endTime?.minute()) * 60 * 1000
        if (this.editModel?.show) {
          let res = await this.$http.addWatchRoom({
            schoolId: school.id || '',
            schoolCode: school.schoolId || '',
            schoolName: school.schoolName || '',
            classCode: classRoom.classroomCode || '',
            className: classRoom.classroomName || '',
            supporterName: teacher.realName || '',
            supporterPhone: teacher.mobile || '',
            supporterId: teacher.zhsId || '',
            supporterEmail: teacher.email || '',
            liveId: this.editModel.liveId,
            startTime: submitStartTime,
            endTime: submitEndTime,
            classroomTypeName: classRoom.classroomTypeName
          })
          if (res.rt.resultStatus == -1 || res.code != 200) {
            return this.$message.error(res.rt.resultMessage || '添加失败')
          }
          this.listenData.push({
            key: this.listenData.length,
            schoolId: school.id || '',
            schoolName: school.schoolName || '',
            schoolCode: school.schoolId || '',
            className: classRoom.classroomName || '',
            classId: classRoom.classroomCode || '',
            roomType: '听课',
            realName: teacher.realName || '',
            mobile: teacher.mobile || '',
            zhsId: teacher.zhsId || '',
            email: teacher.email || '',
            classroomTypeName: classRoom.classroomTypeName
          })
        } else {
          this.listenData.push({
            key: this.listenData.length,
            schoolId: school.id || '',
            schoolName: school.schoolName || '',
            schoolCode: school.schoolId || '',
            className: classRoom.classroomName || '',
            classId: classRoom.classroomCode || '',
            roomType: '听课',
            realName: teacher.realName || '',
            mobile: teacher.mobile || '',
            zhsId: teacher.zhsId || '',
            email: teacher.email || '',
            classroomTypeName: classRoom.classroomTypeName
          })
        }
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let data = this.smallestForm.getFieldsValue()
        let school =
          this.schoolListWis?.find((item) => item.id == data.listenSchool) || {}
        let classRoom =
          this.listenClassRoomListSma?.find(
            (item) => item.classroomCode == data.listenClassroom
          ) || {}
        let teacher =
          this.teacherListListenSma?.find(
            (item) => item.zhsId == data.listenDaobo
          ) || {}
        if (!data.listenSchool) {
          return
        }
        let selectDay = data.courseTimeWis
        selectDay?.hours(0)
        selectDay?.minutes(0)
        selectDay?.seconds(0)
        let submitStartTime =
          selectDay?.valueOf() +
          (data.startTime?.hour() * 60 + data.startTime?.minute()) * 60 * 1000
        let submitEndTime =
          selectDay?.valueOf() +
          (data.endTime?.hour() * 60 + data.endTime?.minute()) * 60 * 1000
        if (this.editModel?.show) {
          let res = await this.$http.addWatchRoom({
            schoolCode: school.schoolId || '',
            schoolName: school.schoolName || '',
            classCode: classRoom.classroomCode || '',
            className: classRoom.classroomName || '',
            supporterName: teacher.realName || '',
            supporterPhone: teacher.mobile || '',
            supporterId: teacher.zhsId || '',
            supporterEmail: teacher.email || '',
            liveId: this.editModel.liveId,
            startTime: submitStartTime,
            endTime: submitEndTime,
            classroomTypeName: classRoom.classroomTypeName
          })
          if (res.rt.resultStatus == -1 || res.code != 200) {
            return this.$message.error(res.rt.resultMessage || '添加失败')
          }
          this.listenDataSma.push({
            key: this.listenDataSma.length,
            schoolName: school.schoolName || '',
            schoolId: school.schoolId || '',
            className: classRoom.classroomName || '',
            classId: classRoom.classroomCode || '',
            roomType: '听课',
            realName: teacher.realName || '',
            mobile: teacher.mobile || '',
            zhsId: teacher.zhsId || '',
            email: teacher.email || '',
            classroomTypeName: classRoom.classroomTypeName
          })
        } else {
          this.listenDataSma.push({
            key: this.listenDataSma.length,
            schoolName: school.schoolName || '',
            schoolId: school.schoolId || '',
            className: classRoom.classroomName || '',
            classId: classRoom.classroomCode || '',
            roomType: '听课',
            realName: teacher.realName || '',
            mobile: teacher.mobile || '',
            zhsId: teacher.zhsId || '',
            email: teacher.email || '',
            classroomTypeName: classRoom.classroomTypeName
          })
        }
      }
      // this.deleteModalShow = true
      // this.deleteData = data
      const resForEditLiveDetail = await this.$http.getLcLiveInfo({
        liveId: this.editModel.liveId,
      })
      const editFormDataNew = resForEditLiveDetail.rt
      this.listenData =
      editFormDataNew.watchClassList?.map((item, index) => {
        return {
          key: index,
          schoolId: item.id,
          schoolName: item.schoolName,
          schoolCode: item.schoolId,
          className: item.className,
          roomType: '听课',
          realName: item.supporterName,
          mobile: item.supporterPhone,
          schoolCode: item.schoolCode,
          classCode: item.classCode,
          email: item.email,
          liveId: item.liveId,
        }
      }) || []
    },
    // 听课学校改变
    async handleListenSchoolChange(value) {
      if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let schoolData =
          this.schoolListWis.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.getListenClassRoomListForAll({
          schoolId: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.listenClassRoomList = classRoomRes.rt
        this.wisdomForm.resetFields(['listenClassroom', 'listenDaobo'])
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let schoolData =
          this.schoolListWis.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.getAllClassroomBySchoolCode({
          schoolId: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.listenClassRoomListSma = classRoomRes.rt
        this.smallestForm.resetFields(['listenClassroom', 'listenDaobo'])
      }
    },
    async handleListenClassRoomChange(value) {
      if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let teacherRes = await this.$http.getSelectTeacherList({
          classCodes: value,
        })
        if (teacherRes.code !== 200) return this.$message.error(teacherRes.msg)
        this.teacherListListenWis = teacherRes.rt[value]
        this.wisdomForm.resetFields(['listenDaobo'])
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let teacherRes = await this.$http.getSelectTeacherList({
          classCodes: value,
        })
        if (teacherRes.code !== 200) return this.$message.error(teacherRes.msg)
        this.teacherListListenSma = teacherRes.rt[value]
        this.smallestForm.resetFields(['listenDaobo'])
      }
    },
    async handleSchoolChange(value) {
      // value = id 唯一的学校id
      if (this.roomType === ROOM_TYPE_ENUM.SIMPLE) {
        let schoolData =
          this.schoolListSim.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.liveListClassRoomBySchoolId({
          schoolId: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.classRoomListSim = classRoomRes.rt.list || []
        this.simpleForm.resetFields(['classRoomId', 'teacherId'])
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let schoolData =
          this.schoolListWis.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.getSelectClassRoomList({
          schoolCode: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.classRoomListWis = classRoomRes.rt || []
        this.wisdomForm.resetFields(['classRoomId', 'teacherId'])
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let schoolData =
          this.schoolListWis.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.getSmallestClassRoomList({
          schoolId: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.classRoomListSma = classRoomRes.rt || []
        this.smallestForm.resetFields(['classRoomId', 'teacherId'])
      }
    },
    async handleClassRoomChange(value, isSelect) {
      if (this.roomType === ROOM_TYPE_ENUM.SIMPLE) {
        let schoolData =
          this.schoolListSim.find(
            (item) => item.id == this.simpleForm.getFieldValue('schoolId')
          ) || {}
        let teacherRes = await this.$http.liveListTeacherBySchoolId({
          schoolId:
            this.editModel?.show && !isSelect ? value : schoolData.schoolId,
        })
        if (teacherRes.code !== 200) {
          this.$message.error(teacherRes.msg)
          return
        }
        this.teacherListSim = teacherRes.rt?.list?.map((item) => {
          return {
            zhsId: item.id,
            realName: item.name,
          }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let teacherRes = await this.$http.getSelectTeacherList({
          classCodes: value,
        })
        if (teacherRes.code !== 200) {
          this.$message.error(teacherRes.msg)
          return
        }
        this.teacherListWis = teacherRes.rt[value]
        this.wisdomForm.resetFields(['teacherId'])
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let teacherRes = await this.$http.getAllRoomDaoboDetail()
        if (teacherRes.code !== 200) {
          this.$message.error(teacherRes.msg)
          return
        }
        this.teacherListSma = teacherRes.rt || []
        this.wisdomForm.resetFields(['teacherId'])
      }
    },
    async saveClassRoom() {
      this.handScrollChange()
      if (this.roomType === ROOM_TYPE_ENUM.SIMPLE) {
        // 极简教室表单校验和处理提交数据
        this.simpleForm.validateFieldsAndScroll(async (error) => {
          if (!error) {
            let data = this.simpleForm.getFieldsValue()
            // 校验
            if (data.courseName.length > 50) {
              return this.$message.error('直播名称不得大于50字')
            }
            let selectDay = data.courseTime
            selectDay?.hours(0)
            selectDay?.minutes(0)
            selectDay?.seconds(0)
            let submitStartTime =
              selectDay?.valueOf() +
              (data.startTime?.hour() * 60 + data.startTime?.minute()) *
                60 *
                1000
            let submitEndTime =
              selectDay?.valueOf() +
              (data.endTime?.hour() * 60 + data.endTime?.minute()) * 60 * 1000
            let zjTeacherData =
              this.teacherListSim.find(
                (item) => item.zhsId == data.teacherId
              ) || {}
            let schoolData =
              this.schoolListSim.find((item) => item.id == data.schoolId) || {}
            let submitData = {
              schoolId: schoolData.schoolId || '',
              schoolCode: schoolData.id || '',
              classRoomId: data.classRoomId || '',
              teacherId: data.teacherId || '',
              teacherName: zjTeacherData.realName,
              courseName: data.courseName || '',
              timeList: [
                {
                  startTime: submitStartTime,
                  endTime: submitEndTime,
                },
              ],
            }
            // 检查开始时间是否大于结束时间  是的话就给出错误提示并阻止提交
            if (submitStartTime > submitEndTime) {
              this.$message.error('开始时间不能晚于结束时间！')
              return
            }
            if (this.courseInfo?.show) {
              submitData.courseId = this.courseInfo.courseId
            }
            if (this.editModel?.show) {
              submitData.liveId = this.editModel.liveId
            }
            this.submitLoading = true
            let result = {}
            if (this.editModel?.show) {
              result = await this.$http.editSimpleLive(submitData)
            } else {
              result = await this.$http.createClassLive(submitData)
            }
            // 多个Loading false 是正确提交为了防重
            if (result.code !== 200) {
              this.submitLoading = false
              return this.$message.error(result.msg)
            }
            let { rt: resultReally } = result
            if (resultReally.resultStatus !== 1) {
              this.submitLoading = false
              return this.$message.error(
                resultReally.resultMessage
                  ? resultReally.resultMessage
                  : this.editModel?.show
                  ? '编辑失败'
                  : '创建失败'
              )
            }
            this.$message.success(
              this.editModel?.show ? '编辑直播成功' : '创建直播成功'
            )
            this.loadingTimer = setTimeout(() => {
              this.$emit('refresh')
              this.submitLoading = false
              this.showModal = false
            }, 1500)
            // 重置表单
            // this.simpleForm.resetFields()
          }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        // 智慧教室表单校验和处理提交数据
        this.wisdomForm.validateFieldsAndScroll(async (error) => {
          if (!error) {
            let data = this.wisdomForm.getFieldsValue()
            // 校验
            if (data.liveName.length > 50) {
              return this.$message.error('直播名称不得大于50字')
            }
            // 时间处理
            let selectDay = data.courseTimeWis
            selectDay?.hours(0)
            selectDay?.minutes(0)
            selectDay?.seconds(0)
            let submitStartTime =
              selectDay?.valueOf() +
              (data.startTime?.hour() * 60 + data.startTime?.minute()) *
                60 *
                1000
            let submitEndTime =
              selectDay?.valueOf() +
              (data.endTime?.hour() * 60 + data.endTime?.minute()) * 60 * 1000
            // 主讲教室处理
            let zjSchoolData =
              this.schoolListWis.find((item) => item.id == data.schoolId) || {}
            let zjClassRoomData =
              this.classRoomListWis.find(
                (item) => item.classroomCode == data.classRoomId
              ) || {}
            let zjTeacherData =
              this.teacherListWis.find(
                (item) => item.zhsId == data.teacherId
              ) || {}
            let teachClass = {
              schoolCode: zjSchoolData.schoolId || '',
              schoolId: zjSchoolData.id || '',
              schoolName: zjSchoolData.schoolName || '',
              classCode: zjClassRoomData.classroomCode || '',
              className: zjClassRoomData.classroomName || '',
              supporterName: zjTeacherData.realName || '',
              supporterPhone: zjTeacherData.mobile || '',
              supporterZhsId: zjTeacherData.zhsId || '',
              supporterEmail: zjTeacherData.email || '',
              tactics: data.tactics || '',
              teachPhone: data.teachPhone || '',
              classroomTypeName: zjClassRoomData.classroomTypeName
            }

            // 收视教室处理
            let watchClassList = this.listenData.map((item) => {
              return {
                schoolId: item.schoolId,
                schoolCode: item.schoolCode,
                schoolName: item.schoolName,
                classCode: item.classId,
                className: item.className,
                supporterName: item.realName,
                supporterPhone: item.mobile,
                supporterZhsId: item.zhsId,
                supporterEmail: item.email,
                classroomTypeName: item.classroomTypeName
              }
            })
            let submitData = {
              liveName: data.liveName || '',
              teacherName: data.teacherName || '',
              liveClassType: 1,
              startTime: submitStartTime,
              endTime: submitEndTime,
              teachClass,
              watchClassList,
              teachPhone: data.teachPhone || '',
            }
            // 检查开始时间是否大于结束时间  是的话就给出错误提示并阻止提交
            if (submitStartTime > submitEndTime) {
              this.$message.error('开始时间不能晚于结束时间！')
              return
            }
            if (this.courseInfo?.show) {
              submitData.courseId = this.courseInfo.courseId
            }
            if (this.editModel?.show) {
              submitData.liveId = this.editModel.liveId
            }
            this.submitLoading = true
            let result = {}
            try {
              if (this.editModel?.show) {
                result = await this.$http.editLcLiveInfo(submitData)
              } else {
                result = await this.$http.createLCClassLive(submitData)
              }
            } catch (error) {
              this.submitLoading = false
              return this.$message.error('服务端开小差了')
            }
            if (result.code !== 200) {
              this.submitLoading = false
              return this.$message.error(result.msg)
            }
            if (result.rt !== '') {
              this.submitLoading = false
              return this.$message.error(
                result.rt
                  ? result.rt
                  : this.editModel?.show
                  ? '编辑失败'
                  : '创建失败'
              )
            }
            this.$message.success(
              this.editModel?.show ? '编辑直播成功' : '创建直播成功'
            )
            this.loadingTimer = setTimeout(() => {
              this.$emit('refresh')
              this.submitLoading = false
              this.showModal = false
            }, 1500)
          }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        // 极简做主讲教室表单校验和处理提交数据
        this.smallestForm.validateFieldsAndScroll(async (error) => {
          if (!error) {
            let data = this.smallestForm.getFieldsValue()
            // 校验
            if (data.liveName.length > 50) {
              return this.$message.error('直播名称不得大于50字')
            }
            // 时间处理
            let selectDay = data.courseTimeWis
            selectDay?.hours(0)
            selectDay?.minutes(0)
            selectDay?.seconds(0)
            let submitStartTime =
              selectDay?.valueOf() +
              (data.startTime?.hour() * 60 + data.startTime?.minute()) *
                60 *
                1000
            let submitEndTime =
              selectDay?.valueOf() +
              (data.endTime?.hour() * 60 + data.endTime?.minute()) * 60 * 1000
            // 主讲教室处理
            let zjSchoolData =
              this.schoolListWis.find((item) => item.id == data.schoolId) || {}
            let zjClassRoomData =
              this.classRoomListSma.find(
                (item) => item.classroomCode == data.classRoomId
              ) || {}
            let zjTeacherData =
              this.teacherListSma.find(
                (item) => item.zhsId == data.teacherId
              ) || {}
            let teachClass = {
              schoolCode: zjSchoolData.schoolId || '',
              schoolId: zjSchoolData.id || '',
              schoolName: zjSchoolData.schoolName || '',
              classCode: zjClassRoomData.classroomCode || '',
              className: zjClassRoomData.classroomName || '',
              supporterName: zjTeacherData.realName || '',
              supporterPhone: zjTeacherData.mobile || '',
              supporterZhsId: zjTeacherData.zhsId || '',
              supporterEmail: zjTeacherData.email || '',
              tactics: data.tactics || '',
              teachPhone: data.teachPhone || '',
              classroomTypeName: zjClassRoomData.classroomTypeName
            }

            // 收视教室处理
            let watchClassList = this.listenDataSma.map((item) => {
              return {
                schoolId: item.schoolId,
                schoolCode: item.schoolId,
                schoolName: item.schoolName,
                classCode: item.classId,
                className: item.className,
                supporterName: item.realName,
                supporterPhone: item.mobile,
                supporterZhsId: item.zhsId,
                supporterEmail: item.email,
                classroomTypeName: item.classroomTypeName
              }
            })
            let submitData = {
              liveName: data.liveName || '',
              teacherName: data.teacherName || '',
              liveClassType: 0,
              startTime: submitStartTime,
              endTime: submitEndTime,
              teachClass,
              watchClassList,
              teachPhone: data.teachPhone || '',
            }
            // 检查开始时间是否大于结束时间  是的话就给出错误提示并阻止提交
            if (submitStartTime > submitEndTime) {
              this.$message.error('开始时间不能晚于结束时间！')
              return
            }
            if (this.courseInfo?.show) {
              submitData.courseId = this.courseInfo.courseId
            }
            if (this.editModel?.show) {
              submitData.liveId = this.editModel.liveId
            }
            this.submitLoading = true
            let result = {}
            try {
              if (this.editModel?.show) {
                result = await this.$http.editLcLiveInfo(submitData)
              } else {
                result = await this.$http.createLCClassLive(submitData)
              }
            } catch (error) {
              this.submitLoading = false
              return this.$message.error('服务端开小差了')
            }
            if (result.code !== 200) {
              this.submitLoading = false
              return this.$message.error(result.msg)
            }
            if (result.rt !== '') {
              this.submitLoading = false
              return this.$message.error(
                result.rt
                  ? result.rt
                  : this.editModel?.show
                  ? '编辑失败'
                  : '创建失败'
              )
            }
            this.$message.success(
              this.editModel?.show ? '编辑直播成功' : '创建直播成功'
            )
            this.loadingTimer = setTimeout(() => {
              this.$emit('refresh')
              this.submitLoading = false
              this.showModal = false
            }, 1500)
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .classmodal_content {
  .ant-form-item-label {
    line-height: 26px;
  }
  .content_btntab {
    display: flex;
    margin-bottom: 15px;
    button:first-child {
      margin-right: 30px;
    }
    button:nth-child(2) {
      margin-right: 30px;
    }
    > button {
      width: 150px;
      &:hover {
        border: 1px solid #d9d9d9 !important;
      }
    }
    .ant-btn-default {
      background-color: #efefef;
      color: #7f7f7f;
    }
    .ant-btn {
      &:active {
        border: none;
      }
      &:hover {
        border: none;
      }
      &:focus {
        border: none;
      }
    }
  }
  .ant-form-item {
    margin-bottom: 0;
  }
  .simple_box {
  }
  h3 {
    margin-top: 20px;
    font-weight: bold;
  }
  .scroll-box {
    overflow-y: scroll;
    max-height: 500px;
    .content_table {
      margin-top: 15px;
    }
    .add_class_room_btn {
      position: absolute;
      right: -145px;
      top: -9px;
    }
  }
}
</style>
